export const DEFAULT_HEADER_MAIN_LABEL = 'REGISTRO DA QUALIDADE';

export const HEADER_HORIZONTAL_MARGIN = 24;

export const DEFAULT_HEADER_MARGIN = {
  top: 15,
  right: HEADER_HORIZONTAL_MARGIN,
  bottom: 0,
  left: HEADER_HORIZONTAL_MARGIN,
} as const;
